/**
 * Who operates Fronted, in one place.
 *
 * Not a credit line. Three separate obligations land on the same few facts:
 * Google's OAuth verification wants a privacy policy on this domain naming an
 * identifiable operator; GDPR Art. 14 wants the controller named to people
 * whose data arrived from somebody else — which is every payer, invited by a
 * manager who pasted their address; and the EU/UK e-commerce rules want a
 * name, a geographic address and an email reachable from the site.
 *
 * A module constant rather than a fetch. The public pages are eager for a
 * reason (see `router.tsx`) — a stranger on a phone on a bad network must not
 * wait on a second round trip, and least of all for a footer. These values are
 * public, static, and change roughly never.
 *
 * POSTAL_ADDRESS must match `COMPANY_ADDRESS` in the API's env: the same
 * address has to appear in the mail, where CAN-SPAM is the one asking. If they
 * disagree, the mail is the one that matters.
 */
export const company = {
  /** The entity operating the service, not the one that wrote the code. */
  name: 'Prosaic Solutions',

  /**
   * Must match `SUPPORT_EMAIL` in the API env — it is the address the privacy
   * policy tells people to use, so it needs a mailbox somebody reads.
   */
  email: 'report@fronted.app',

  /**
   * Empty until somebody fills it in, and empty renders nothing rather than a
   * placeholder. A visibly fake address in a privacy policy is worse than a
   * missing one: the missing one is an obvious gap, the fake one looks done.
   */
  postalAddress: '',
} as const

// The effective date moved to the API with the text it dates: Privacy and
// Terms are server-rendered documents now (`app/routers/legal.py`), and a
// constant here would only be a second date to forget.
